import isArray from 'lodash/isArray'
import get from 'lodash/get'

import { brandsForUpsellOptions, baseFareTileData, dedupSlices, dedupBrandsInSlices } from './helpers'

export default function getUpsellOptionsBySlice(itinerary, brandReference, rawSlices) {
  if (!isArray(brandReference) || itinerary.isFused) return []

  let upsellsBySlice = get(itinerary, 'slices', []).reduce((upsellSlices, curSlice) => {
    const upsellBrands = brandsForUpsellOptions(brandReference, itinerary.upsellOptions, rawSlices)
    const baseFare = baseFareTileData(itinerary, brandReference, curSlice)

    upsellSlices.push([baseFare, ...upsellBrands])
    return upsellSlices
  }, [])

  upsellsBySlice = dedupSlices(dedupBrandsInSlices(upsellsBySlice))

  // Until we support split itins, ignore non-split RT that has different brands per slice
  return upsellsBySlice.length > 1 ? [] : upsellsBySlice
}
